export default __webpack_public_path__ + "static/refiner-offices-89c40e501b8bd8bdb75f9715688d7b1a.jpg";